import { Injectable } from '@angular/core';

/**
 * Methods on this service get registered as "logic functions" on LogicService
 */
@Injectable({ providedIn: 'root' })
export class OaoCardValidationFunctionsService {}
